<script lang="ts">
  import LL from '$i18n/i18n-svelte';
  import { durationToString } from '$lib/utils/number';
  import { Hourglass } from 'lucide-svelte';
  import MatchDetailsPlayer from './match-details-player.svelte';
  import type ERAR from '$lib/erar/spec';

  export let isMyTeam: boolean;
  export let rank: number;
  export let players: ERAR.Schema.MatchParticipation[];

  $: tk = players.map((p) => p.kill).reduce((sum, v) => sum + v);
  $: totalDeal = players.map((p) => p.totalDeal).reduce((sum, v) => sum + v);
  $: totalCredit = players.map((p) => p.totalCredit ?? 0).reduce((sum, v) => sum + v);
</script>

<section class="match-details-team" data-myteam={isMyTeam}>
  <div class="meta">
    <span class="rank">#{rank}</span>
    <div class="meta-item duration">
      <span class="category"><Hourglass size="10" /></span>
      {durationToString(players[0].duration)}
    </div>
    <div class="meta-item"><span class="category">TK</span> {tk}</div>
    <div class="meta-item">
      <span class="category">{$LL.players.detail.totalDeal()}</span>
      {totalDeal}
    </div>
    <div class="meta-item">
      <span class="category">{$LL.players.detail.totalCredit()}</span>
      {totalCredit}
    </div>
  </div>
  <div class="teammates">
    <ul>
      {#each players as participation}
        <MatchDetailsPlayer match={participation} />
      {/each}
    </ul>
  </div>
</section>

<style lang="postcss">
  .match-details-team {
    display: flex;
    flex-direction: column;
    background-color: var(--mauve-a1);

    .rank {
      font-size: var(--size-7);
      font-weight: bold;
    }

    &[data-myteam='true'] {
      background-color: var(--orange-a2);
    }
  }

  .teammates {
    display: flex;
    flex-direction: column;
    margin: var(--space-3);
    margin-top: 0;
    background-color: var(--mauve-a1);
    border: 1px solid var(--border-normal);
    border-radius: var(--radius-2);
  }

  .meta {
    display: flex;
    gap: var(--space-5);
    align-items: center;
    padding: var(--space-3);
    margin-left: var(--space-3);
    margin-right: var(--space-3);
    font-size: var(--size-5);

    .meta-item {
      display: flex;
      flex-direction: column;
    }
    .meta-item.duration {
      flex-direction: row;
      gap: var(--space-1);
      align-items: center;
      margin-right: auto;
    }

    .category {
      color: var(--text-dimmed);
      font-size: var(--size-4);
    }
  }
</style>
